import React from 'react';

/** Placeholder Control Centre — parity with pre-refactor dashboard. */
export function ControlCentreSection() {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Control Centre</h2>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Control centre content will go here...</p>
      </div>
    </div>
  );
}
